import React, { useEffect } from 'react';
import { Inbox as HostbuddyInbox } from '@hostbuddy-frontend-dev/inbox';
import Loader from 'components/loader/Loader';
import useAppUser from 'hooks/useAppUser';
import {
  hostbuddyApiBaseUrl,
  hostbuddyApiKey,
} from '../../aiHub/HostbuddyAI.constants';
import useSignAudienceScopedToken from './useSignAudienceScopedToken';

const accessTokenKey = 'hbai_access_token';
const accessTokenExpiryKey = 'hbai_access_token_expiry';

function shouldRequestNewToken() {
  return (
    !localStorage.getItem(accessTokenKey) ||
    !localStorage.getItem(accessTokenExpiryKey) ||
    Number(localStorage.getItem(accessTokenExpiryKey)) < Date.now()
  );
}

const HostbuddyInboxWrapper = () => {
  const { agencyUid } = useAppUser();

  const requestNewToken = shouldRequestNewToken();

  const { isLoading, data } = useSignAudienceScopedToken({
    agencyUid: agencyUid!,
    audience: 'hf-assist',
    enabled: requestNewToken,
  });

  useEffect(() => {
    if (data?.accessToken && data?.expiresIn) {
      localStorage.setItem(accessTokenKey, data.accessToken);
      localStorage.setItem(
        accessTokenExpiryKey,
        String(Date.now() + data.expiresIn * 1000 - 3600 * 1000), // request new token 1 hour before expiry
      );
    }
  }, [data?.accessToken, data?.expiresIn]);

  if (requestNewToken && isLoading) {
    return <Loader />;
  }

  return <HostbuddyInbox config={{ hostbuddyApiBaseUrl, hostbuddyApiKey }} />;
};

export default HostbuddyInboxWrapper;
